import { combineReducers } from '@reduxjs/toolkit'

import { basemapReducer, estimateReducer } from '../pages/Estimate/redux'

import { appReducer } from './appSlice'

const rootReducer = combineReducers({
  ...appReducer,
  ...basemapReducer,
  ...estimateReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default (state: any, action: any) => {
  if (action.type === 'auth/logout') {
    // eslint-disable-next-line no-param-reassign
    state = undefined
  }

  return rootReducer(state, action)
}
